import { render, staticRenderFns } from "./MoleculeCardHeaderBodyFooter.vue?vue&type=template&id=61deff86&scoped=true"
import script from "./MoleculeCardHeaderBodyFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./MoleculeCardHeaderBodyFooter.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61deff86",
  null
  
)

export default component.exports